import { render, staticRenderFns } from "./item-template.vue?vue&type=template&id=2622c78a&"
import script from "./item-template.vue?vue&type=script&lang=js&"
export * from "./item-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports